import { render, staticRenderFns } from "./Language2.vue?vue&type=template&id=47cc44d1&scoped=true"
import script from "./Language2.vue?vue&type=script&lang=js"
export * from "./Language2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc44d1",
  null
  
)

export default component.exports